import Axios from "axios";
import KnockOut from "knockout";
import KnockOutMapping from "knockout-mapping";

export default class CartPreviewViewModel {
    constructor() {
        let self: any = this;

        self.isDataFetched = KnockOut.observable(false);

        self.update = function (cartInfo: any) {
            KnockOutMapping.fromJS(cartInfo, {}, self);
            self.isDataFetched(true);
        };

        self.animate = function () {
            var $cartPreview = $("#CartPreview");
            $("html, body").animate({ scrollTop: 0 }, 300);
            $cartPreview.attr("data-hover", "true");
            setTimeout(function () { $cartPreview.attr("data-hover", ""); }, 3000);
        };

        self.checkoutSummary = function (cartInfo: any) {
            if ((<any>window).sendinblue) {
                var track_event = { "data": { "items": [] } };

                for (var i = 0; i < cartInfo.cartRows().length; i++) {
                    var cartRow = {
                        "ProductName": cartInfo.cartRows()[i].productName(),
                        "ProductImageUrl": "/it/media/product/images/150-150-fix/" + cartInfo.cartRows()[i].productImageCode(),
                        "Quantity": cartInfo.cartRows()[i].quantity(),
                        "VariantCode": cartInfo.cartRows()[i].variantCode(),
                        "VariantName": cartInfo.cartRows()[i].variantDescription(),
                        "UnitPrice": cartInfo.cartRows()[i].unitPrice(),
                        "TotalPrice": cartInfo.cartRows()[i].rowPrice()
                    };
                    track_event.data.items.push(cartRow);
                }

                (<any>window).sendinblue.track("Click_Finestra_Completa_Ordine", {}, track_event);
            }

            location.href = (<any>window).App.routes.Checkout_Summary;
        };

        async function init() {
            let cartInfo = (await Axios.post((<any>window).App.routes.Cart_GetCartInfo)).data;
            self.update(cartInfo);
        }

        init();
    }
}